
import wx from 'weixin-js-sdk';
import {urlConfig} from '@/api/urlConfig'
import {fetch, promptMessage, baseUrl } from '@/api/dataHandling'
import {getken} from '@/api/getToken'
import axios from 'axios'
import Confirm from 'vux/src/components/confirm/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
data(){
return{
confirmshow:false,
dection:[
'1.基础诊查费200元/次，院内专家会诊费 100元/人/次，专家至少三人，MDT诊查费合计至少500元;',
'2.确定预约时间及专家后如需退费，仅退院内专家会诊费；'
],
pointerCancelIcon:true,
toastShow: false,
toastTxt: '',
submitDisable:false,
getdata:{
identityNo:'',
birthday:'',
patientName:'',
},
pointerCancel:'',
formdata:{
remark:'',
situDesc:'',
need:'',
pointerCancel:'',
},
pointerCanceloptions: [],
}
},
directives: {
TransferDom
},
components: {
Confirm,Cell,Toast, Icon, Grid, GridItem, GroupTitle, XTextarea, XHeader, XButton, Group,Checker, CheckerItem
},
methods:{
onConfirm(){
this.submitdisabled = true;
fetch('post',urlConfig.mdtregisterSave,this.formdata).then(response => {
promptMessage('提示','登记成功！')
this.submitdisabled = false;
}).catch(error => {
this.submitdisabled = false;
});
this.confirmshow = false;
}, //确认
yanzheng(){
if(this.formdata.pointerCancel){
this.pointerCancelIcon = false
}else {
this.pointerCancelIcon = true;
};
},
IconClick (text) {
this.toastShow = true;
this.toastTxt = text;
},
radioChoose(obj){
let pointerCancelstring = [];
for(let i=0;i<this[obj].length;i++){
pointerCancelstring.push(this[obj][i].sZdDm);
}
this.formdata[obj] = pointerCancelstring.toString();
this.yanzheng();
console.log(this.formdata[obj],5)
},
sureClick(){
console.log(this.formdata)
if(this.formdata.pointerCancel){
this.confirmshow = true;

}else{
promptMessage('提示','请选择入组条件！');
}

},
getSFZ(){
fetch('get',urlConfig.GetSfzh +'?openid='+this.openid).then(response => {
this.getPersonInfoId(response.sfzh);
}).catch(error => {


})
},
getBasicInfor(){
fetch('get',urlConfig.patientBasicInfosGet + '?personInfoId='+this.formdata.personInfoId).then(response => {
this.getdata = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});

}).catch(error => {

})
},  //获取患者基本信息
getPersonInfoId(sfzh){

fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.formdata.personInfoId = response.personInfoId
this.getBasicInfor();
}).catch(error => {

})
this.getdataopntion();
},
getdataopntion(){
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
axios.get(baseUrl + urlConfig.getIVF+'/9976').then(response => {

this.pointerCanceloptions = response.data.data;

}).catch(error => {

});
},
getopenid(code){
let cutton = 'http://front.wh.jinxin-fertility.com/mdtregister';
axios.get('http://front.wh.jinxin-fertility.com/weixin/getOpenIdByCode?code=' +  code).then(response => {
if(response.data.resultCode == 'success'){
if(response.data.openid.trim() !=''){
this.openid = response.data.openid;
getken(this.getSFZ);
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}

}).catch(function (error) {
promptMessage('提示' +error)
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});

});
},
getUrlParam (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
let url = location.href;
let search = url.split('?')[1]
if (search) {
var r = search.substr(0).match(reg)
if (r !== null) return decodeURI(r[2])
return null
} else {
return null
}
},
},
mounted() {
let _this = this;
/*    getken(this.getPersonInfoId('51132119931110772X'));*/

this.$store.commit('updateLoadingStatus',{isLoading:true});
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)).then(response => {
this.weixindata = response.data;
const code = _this.getUrlParam('code');
if(!_this.$route.query.code){   // 地址栏没有code
var appid = response.data.appId;
console.log(location.href)
var redirect_uri = encodeURIComponent(location.href);
if(code == null || code === ''){
window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
}
}else{
if(window.localStorage.getItem('openid')){
_this.openid = window.localStorage.getItem('openid')
getken(_this.getSFZ);
}else{
_this.getopenid(_this.$route.query.code)
}

}

}).catch(function (error) {
promptMessage('提示' +error)

});
}
}



// WEBPACK FOOTER //
// ./src/project/mdt/mdtregister.vue